import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LuChevronDown, LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import { formatReportRange } from '../../utils/weekFormat.js';
import IconButton from '../ui/IconButton';

/**
 * ‹ [week select] › — moves between the reports of the client, keeping the current tab.
 * Native select on purpose: long lists, keyboard and mobile pickers come for free.
 */
const WeekSwitcher = ({ weeks = [], currentId, slug, search = '', isAdminUser }) => {
  const navigate = useNavigate();
  const index = weeks.findIndex((w) => w.id === currentId);
  const older = index >= 0 ? weeks[index + 1] : null;
  const newer = index > 0 ? weeks[index - 1] : null;
  const go = (week) => week && navigate(`/w/${slug}/${week.id}${search}`);

  if (weeks.length < 2 || index < 0) return null;

  return (
    <div className="flex w-full min-w-0 items-center gap-1 sm:w-auto">
      <IconButton icon={LuChevronLeft} label={older ? `Semaine précédente (S${older.week_number})` : 'Pas de semaine précédente'} variant="outline" size="md" disabled={!older} onClick={() => go(older)} />
      <div className="relative min-w-0 flex-1 sm:flex-none">
        <select
          value={currentId}
          onChange={(e) => go(weeks.find((w) => w.id === e.target.value))}
          aria-label="Changer de semaine"
          className="h-9 w-full cursor-pointer appearance-none truncate rounded-lg border border-gray-200 bg-white py-0 pl-3 pr-8 text-sm font-medium text-gray-700 shadow-sm outline-none hover:bg-gray-50 focus-visible:ring-2 focus-visible:ring-brand-500 dark:border-gray-700 dark:bg-night-800 dark:text-gray-200 dark:hover:bg-night-750"
        >
          {weeks.map((w) => (
            <option key={w.id} value={w.id}>
              {`S${w.week_number} · ${formatReportRange(w)}${isAdminUser && w.status !== 'published' ? ' (brouillon)' : ''}`}
            </option>
          ))}
        </select>
        <LuChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" aria-hidden />
      </div>
      <IconButton icon={LuChevronRight} label={newer ? `Semaine suivante (S${newer.week_number})` : 'Pas de semaine suivante'} variant="outline" size="md" disabled={!newer} onClick={() => go(newer)} />
    </div>
  );
};

export default WeekSwitcher;
